import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getMappingRoleList } from "../../redux/actions/getMappingRoleListAction";
import { createRoleMapping } from "../../redux/actions/createRoleMappingAction";
import { deleteRoleMapping } from "../../redux/actions/deleteRoleMappingAction";
import { getEntityMappingList } from "../../redux/actions/getEntityMappingListAction";
import { getEntityTypeList } from "../../redux/actions/getEntityTypeListAction";
import { createEntityMappingList } from "../../redux/actions/createEntityMappingAction";
import { deleteEntityMappingList } from "../../redux/actions/deleteEntityMappingAction";
import { addOrUpdateEntityTypeList } from "../../redux/actions/addOrUpdateEntityTypeListAction";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import DeleteIcon from "@mui/icons-material/Delete";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SearchIcon from "@mui/icons-material/Search";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminMappingRole = () => {
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [role, setRole] = useState("");
	const [walletOwnerIdS, setWalletOwnerIdS] = useState("");
	const [roleS, setRoleS] = useState("");
	const [entityType, setEntityType] = useState("");
	const [page, setPage] = useState(0);
	const [Open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getRoleMappingStatus, setGetRoleMappingStatus] = useState(false);
	const [getRoleMappingResArray, setGetRoleMappingResArray] = useState([]);

	const [getEntityTypeStatus, setGetEntityTypeStatus] = useState(false);
	const [getEntityTypeResArray, setGetEntityTypeResArray] = useState([]);

	const [createRoleMappingStatus, setCreateRoleMappingStatus] = useState("");
	const [createRoleMappingResArray, setCreateRoleMappingResArray] = useState(
		[]
	);

	const [deleteRoleMappingStatus, setDeleteRoleMappingStatus] = useState("");
	const [deleteRoleMappingResArray, setDeleteRoleMappingResArray] = useState(
		[]
	);

	const [mappingId, setMappingId] = useState("");

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getEntityTypeListRes = useSelector(
		({ getEntityTypeList }) => getEntityTypeList
	);

	const getRoleMappingListRes = useSelector(
		({ getMappingRoleList }) => getMappingRoleList
	);

	const createRoleMappingRes = useSelector(
		({ createRoleMapping }) => createRoleMapping
	);

	const deleteRoleMappingRes = useSelector(
		({ deleteRoleMapping }) => deleteRoleMapping
	);

	const handleNoticationClose = () => {
		setCreateRoleMappingResArray([]);
		setDeleteRoleMappingResArray([]);
		setWalletOwnerId("");
		setRole("");
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletOwnerId") {
			setWalletOwnerId(value == "Select Level" ? "" : value);
		}

		if (name === "role") {
			setRole(value == "Select Level" ? "" : value);
		}
		if (name === "walletOwnerIdS") {
			setWalletOwnerIdS(value == "Select Level" ? "" : value);
		}

		if (name === "roleS") {
			setRoleS(value == "Select Level" ? "" : value);
		}
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListReq();
			getRoleListReq();
			getRoleMappingListReq();
		}
	}, [regenerateTokenRes.data.status]);



	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						// adminId: "2"
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getWalletOwnerIdAndNameListReq();
	// }, []);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getRoleListReq();
	// }, []);

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getEntityListStatusFunc = () => {
		if (getEntityTypeStatus) {
			if (getEntityTypeListRes.data.status == "success") {
				setGetEntityTypeResArray([].concat(getEntityTypeListRes.data.roleList));
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getEntityListStatusFunc();
	}, [getEntityTypeListRes.data.status]);

	const getEntityTypeListReq = () => {
		setGetEntityTypeStatus(true);
		dispatch(
			getEntityTypeList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						entityType: entityType
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getEntityTypeListReq();
	// }, []);

	const getRoleMappingListReq = () => {
		setOpen(false);
		setGetRoleMappingStatus(true);
		setIsLoading(true);
		dispatch(
			getMappingRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						ownerID: walletOwnerId.split("-")[0],
						role: role
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getRoleMappingListReq();
	// }, []);

	const getRoleMappingStatusFunc = () => {
		if (getRoleMappingStatus) {
			if (getRoleMappingListRes.data.status == "success") {
				setGetRoleMappingResArray(
					[].concat(getRoleMappingListRes.data.roleList)
				);
				setIsLoading(false);
			}
			if (getRoleMappingListRes.data.status == "failed") {
				setGetRoleMappingResArray(getRoleMappingListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getRoleMappingListRes.data.description ||
					getRoleMappingListRes.description
				);
				if (
					getRoleMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getRoleMappingListRes.data.status == "NOT FOUND") {
				setGetRoleMappingResArray(getRoleMappingListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"NOT FOUND",
					getRoleMappingListRes.data.description ||
					getRoleMappingListRes.description
				);
			}
		}
	};

	useEffect(() => {
		getRoleMappingStatusFunc();
	}, [getRoleMappingListRes.data.status]);

	useEffect(() => {
		if (getRoleMappingListRes.data.status == "success") {
			setPage(0);
		}
	}, [getRoleMappingListRes.data.status]);

	const createRoleMappingReq = () => {
		setCreateRoleMappingStatus(true);
		const createMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				ownerID: walletOwnerIdS.split("-")[0],
				roleName: roleS
			}
		};
		dispatch(createRoleMapping(createMappingReq, authToken));
		// console.log("reqqq", createMappingReq)
	};

	const createRoleMappingStatusFunc = () => {
		console.log(getRoleMappingListRes, "/////////////////////////");
		if (createRoleMappingStatus) {
			if (createRoleMappingRes.data.status == "success") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (createRoleMappingRes.data.status == "failed") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					createRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createRoleMappingRes.data.status == "INVALID REQUEST") {
				setCreateRoleMappingResArray(createRoleMappingRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		createRoleMappingStatusFunc();
	}, [createRoleMappingRes.data.status]);

	const deleteEntityMappingReq = () => {
		setDeleteRoleMappingStatus(true);
		const deleteMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				mappingId: mappingId
			}
		};
		dispatch(deleteRoleMapping(deleteMappingReq, authToken));
	};

	console.log(deleteRoleMappingRes, "////////////////////");

	const deleteRoleMappingStatusFunc = () => {
		console.log(deleteRoleMappingRes, "////////////////////1");
		if (deleteRoleMappingStatus) {
			console.log(deleteRoleMappingRes, "////////////////////2");
			if (deleteRoleMappingRes.data.status == "success") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				console.log(deleteRoleMappingRes, "////////////////////3");
				setNotificationOpen(true);
				getRoleMappingListReq();
			}
			if (deleteRoleMappingRes.data.status == "failed") {
				setDeleteRoleMappingResArray(deleteRoleMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteRoleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteRoleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteRoleMappingStatusFunc();
	}, [deleteRoleMappingRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setMappingId("");
		setOpen(false);
		setAddOpen(false);

	};

	const deleteEntity = (mappingid) => {
		setMappingId(mappingid);
		setOpen(true);
	};
	const addRole = () => {
		// setWalletOwnerId('')
		setWalletOwnerIdS('')
		setRoleS('')
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						style={{ padding: "25px", justifyContent: "right" }}
						spacing={2}
					>

						<Grid item md={2} sm={12} xs={12} lg={2}>


							<CustomButton
								style={{
									padding: "8px",
									width: "80px"
								}}
								onClick={() => addRole()}

							>
								Create
							</CustomButton>

						</Grid>

					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								variant="standard"
								name="walletOwnerId"
								value={walletOwnerId || "Select Level"}
								defaultValue={"Select Level" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Role"
								fullWidth={true}
								variant="standard"

								name="role"
								value={role || "Select Level"}
								defaultValue={"Select Level" || role}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Role
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getRoleMappingListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>


					</Grid>


					{/* <DialogTitle>Creating MappingS</DialogTitle>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px"
						}}
					>
						<Grid item xs={12} md={5} sm={3} lg={7}></Grid>
						<Grid item xs={12} md={3} sm={3} lg={2}>

							<CustomButton
								style={{
									padding: "8px"
								}}
							onClick={() => addRole()}

							>
								Create
							</CustomButton>
						</Grid>

					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								variant="standard"
								name="walletOwnerId"
								value={walletOwnerId || "Select Level"}
								defaultValue={"Select Level" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Role"
								fullWidth={true}
								variant="standard"

								name="role"
								value={role || "Select Level"}
								defaultValue={"Select Level" || role}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Role
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={createRoleMappingReq}
							>
								Create
							</Button> */}
					{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={getRoleMappingListReq}
							>
								Search
							</Button> */}
					{/* </Grid> */}
					{/* </Grid> */}
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRoleMappingResArray.length == undefined ||
					!getRoleMappingStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mapping ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Creation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getRoleMappingResArray &&
											[]
												.concat(getRoleMappingResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.walletOwnerName}
														</TableCell>
														<TableCell align="center">{row.role}</TableCell>
														<TableCell align="center">
															{row.creationTime}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => deleteEntity(row.operationId)}
															>
																<DeleteIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getRoleMappingResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={Open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={deleteEntityMappingReq}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>Create Mapping</DialogTitle>
						<DialogContent>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									required
									size="small"
									color="primary"
									type="text"
									label="Owner ID"
									fullWidth={true}
									variant="standard"
									name="walletOwnerIdS"
									// value={walletOwnerId || "Select Level"}
									value={walletOwnerIdS || "Select Level"}

									defaultValue={"Select Level" || walletOwnerIdS}
									onChange={handleChange}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Owner ID
									</MenuItem>
									{getWalletOwnerIdRes.data.ownerList &&
										getWalletOwnerIdResArray.map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									size="small"
									color="primary"
									type="text"
									label="Role"
									fullWidth={true}
									variant="standard"
									required

									name="roleS"
									// value={role || "Select Level"}
									value={roleS || "Select Level"}

									defaultValue={"Select Level" || roleS}
									onChange={handleChange}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Role
									</MenuItem>
									{getRoleListRes.data.roleList &&
										getRoleResArray.map((x) => (
											<MenuItem value={x.role}>{x.role}</MenuItem>
										))}
								</TextField>
							</Grid>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={createRoleMappingReq}
							>
								Create
							</Button> */}
							<DialogActions style={{ padding: "14px" }}>
								<Button
									style={{
										backgroundColor: "#fff",
										color: "#000"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									style={{
										marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white",
										// marginTop: "9px"
									}}
									variant="contained"
									onClick={createRoleMappingReq}
								>
									Create
								</Button>

							</DialogActions>
						</DialogContent>
					</Dialog>
				</div>
			</Layout>

			{createRoleMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createRoleMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createRoleMappingResArray.status == "INVALID REQUEST" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteRoleMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteRoleMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteRoleMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminMappingRole;
